<template>
  <li class="sg-menu-item" @click="handleSelect"><slot /></li>
</template>
<script>
export default {
  props: {
    index: {
      required: true,
      type: [String, Number],
    },
    path: {
      type: String,
    },
     val:{
      type:String,
      default:""
    }
  },
  methods: {
    handleSelect() {
      // this.$parent.$emit("toggle", { key: this.index, path: this.path });
      this.$parent.$emit("select", {
        key: this.index,
        path: this.path,
        val: this.val,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.sg-menu-item {
  padding: 5px 10px;
  line-height: 24px;
  color: #666;
  &:hover {
    background-color: #f2f4f5;
  }
}
</style>
